import { getErrorMessage, isLostResponseError } from './error-utils'

export const UNCONFIRMED_MUTATION_MESSAGE =
  'This change may have been saved. Refresh and review the current record before trying again.'

/** An unknown write outcome takes precedence over a configured "failed/retry" message. */
export function getMutationErrorMessage(
  error: unknown,
  fallback: string,
): string {
  return isLostResponseError(error)
    ? UNCONFIRMED_MUTATION_MESSAGE
    : getErrorMessage(error, fallback)
}
